export default "__VITE_ASSET__7a740feb__"